/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Authorization_Badge_OptionalInputs */

const en_agent_authorization_badge_optional = /** @type {(inputs: Agent_Authorization_Badge_OptionalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Optional. Clear this box to submit without badge access. Seek AI never edits your code or repository directly.`)
};

const zh_agent_authorization_badge_optional = /** @type {(inputs: Agent_Authorization_Badge_OptionalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`此权限可选。取消勾选仍可提交项目，但 Agent 无权添加徽章。Seek AI 服务端不会直接修改你的代码或仓库。`)
};

/**
* | output |
* | --- |
* | "Optional. Clear this box to submit without badge access. Seek AI never edits your code or repository directly." |
*
* @param {Agent_Authorization_Badge_OptionalInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const agent_authorization_badge_optional = /** @type {((inputs?: Agent_Authorization_Badge_OptionalInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Authorization_Badge_OptionalInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_agent_authorization_badge_optional(inputs)
	return zh_agent_authorization_badge_optional(inputs)
});
export { agent_authorization_badge_optional as "agent.authorization.badge_optional" }